import { forwardRef } from 'react';
import styled from '@emotion/styled';
import Paper from 'aquilla/core/atoms/Paper';
import Divider from 'aquilla/core/atoms/Divider';
import { useIsMobile } from '@stores/AppCommonData';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import CompeteInfo from './CompeteInfo';
import RatingChart from './RatingChart/RatingChart';
import useRatingProgressInfo from './useRatingProgressInfo';
import RatingActivity from './RatingActivity/RatingActivity';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_16B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_10B};
  }
`;

const Card = styled(Paper)`
  height: 264px;
  padding: ${Spacings.SPACING_6B};
  margin-top: ${Spacings.SPACING_6B};
  border-radius: ${Spacings.SPACING_2B};
  border: 1px solid var(--color-divider);
  padding-bottom: ${Spacings.SPACING_4B};
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    height: 524px;
    background-color: unset;
    border: none;
    padding: 0;
    margin-top: ${Spacings.SPACING_4B};
    justify-content: flex-start;
  }
`;

const StyledDivider = styled(Divider)`
  margin: 0 ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    margin: ${Spacings.SPACING_4B} 0;
  }
`;

const RatingInfoContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 42px;
  grid-row-gap: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    height: 224px;
  }
`;

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${Spacings.SPACING_10B};
`;

const RatingProgress = forwardRef((_, ref) => {
  const isMobile = useIsMobile();
  const { isLoading } = useRatingProgressInfo();

  const renderLoader = () => {
    return (
      <LoaderContainer>
        <CircularLoader size={40} color="var(--color-i-blue)" />
      </LoaderContainer>
    );
  };

  return (
    <Wrapper ref={ref}>
      <Typography variant={isMobile ? 'h5' : 'h4'}>Rating progress</Typography>
      <Card>
        {isLoading ? (
          renderLoader()
        ) : (
          <>
            <RatingInfoContainer>
              <RatingChart />
              <CompeteInfo isInsideModal={false} />
            </RatingInfoContainer>
            <StyledDivider orientation={isMobile ? 'horizontal' : 'vertical'} />
            <RatingActivity />
          </>
        )}
      </Card>
    </Wrapper>
  );
});

RatingProgress.displayName = 'RatingProgress';
export default RatingProgress;
